import { Routes, RouterModule } from '@angular/router';
import { MetaGuard } from '@ngx-meta/core';

import { VestibularComponent } from './vestibular.component';
import { VestibularCeumaComponent } from './ceuma/ceuma.component';
import { EditaisManuaisComponent } from './editais-manuais/editais-manuais.component';
import { ProvasAplicadasComponent } from './provas-aplicadas/provas-aplicadas.component';
import { ResultadosComponent } from './resultados/resultados.component';
import { CalendarioComponent } from './calendario/calendario.component';
import { AcompanhamentoComponent } from './acompanhamento/acompanhamento.component';
import { environment } from './../../environments/environment';
import { InscricaoVestibularComponent } from './inscricao-vestibular-novo/inscricao-vestibular.component';
import { RedirecionamentoComponent } from './redirecionamento/redirecionamento.component';

const VESTIBULAR_ROUTER: Routes = [
  {
    path: '',
    canActivateChild: [MetaGuard],
    component: VestibularComponent,
    children: [
      { path: '', redirectTo: 'ceuma', pathMatch: 'full' },
      { path: 'ceuma',
        component: VestibularCeumaComponent,
        data: {
          meta: {
            title: `Vestibular ${environment.loginContexto[0].concat(environment.loginContexto.substring(1).toLowerCase())}`,
            description: `Fique por dentro do nosso vestibular${environment.loginContexto=='CEUMA'?' e estude na melhor Universidade do Maranhão':''}.`,
          },
        },
      },
      {
        path: 'editais-manuais',
        component: EditaisManuaisComponent,
        data: {
          meta: {
            title: `Vestibular ${environment.loginContexto[0].concat(environment.loginContexto.substring(1).toLowerCase())} - Editais & Manuais`,
            description: `Fique por dentro do nosso vestibular${environment.loginContexto=='CEUMA'?' e estude na melhor Universidade do Maranhão':''}.`,
          },
        },
      },
      {
        path: 'provas-aplicadas',
        component: ProvasAplicadasComponent,
        data: {
          meta: {
            title: `Provas ${environment.loginContexto[0].concat(environment.loginContexto.substring(1).toLowerCase())} - Anteriores`,
            description: `Fique por dentro do nosso vestibular${environment.loginContexto=='CEUMA'?' e estude na melhor Universidade do Maranhão':''}.`,
          },
        },
      },
      {
        path: 'acompanhamento',
        component: AcompanhamentoComponent,
        data: {
          meta: {
            title: `Vestibular ${environment.loginContexto[0].concat(environment.loginContexto.substring(1).toLowerCase())} - Acompanhamento`,
            description: `Fique por dentro do nosso vestibular${environment.loginContexto=='CEUMA'?' e estude na melhor Universidade do Maranhão':''}.`,
          },
        },
      },
      {
        path: 'resultados',
        component: ResultadosComponent,
        data: {
          meta: {
            title: `Vestibular ${environment.loginContexto[0].concat(environment.loginContexto.substring(1).toLowerCase())} - Resultados`,
            description: `Fique por dentro do nosso vestibular${environment.loginContexto=='CEUMA'?' e estude na melhor Universidade do Maranhão':''}.`,
          },
        },
       },
      {
        path: 'calendario',
        component: CalendarioComponent,
        data: {
          meta: {
            title: `Vestibular ${environment.loginContexto[0].concat(environment.loginContexto.substring(1).toLowerCase())} - Calendário`,
            description: `Fique por dentro do nosso vestibular${environment.loginContexto=='CEUMA'?' e estude na melhor Universidade do Maranhão':''}.`,
          },
        },
       },
       {
        path: 'inscricaoNovo',
        component: InscricaoVestibularComponent,
        data: {
          meta: {
            title: `Vestibular ${environment.loginContexto[0].concat(environment.loginContexto.substring(1).toLowerCase())} - Calendário`,
            description: `Fique por dentro do nosso vestibular${environment.loginContexto=='CEUMA'?' e estude na melhor Universidade do Maranhão':''}.`,
          },
        },
       },
       {
        path: 'redirect/:data',
        component: RedirecionamentoComponent,
       }
    ],
  },
];

export const VestibularRouter = RouterModule.forChild(VESTIBULAR_ROUTER);
